/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaterialDeleteRequest
 */
export interface MaterialDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof MaterialDeleteRequest
     */
    materialId: string;
}

/**
 * Check if a given object implements the MaterialDeleteRequest interface.
 */
export function instanceOfMaterialDeleteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "materialId" in value;

    return isInstance;
}

export function MaterialDeleteRequestFromJSON(json: any): MaterialDeleteRequest {
    return MaterialDeleteRequestFromJSONTyped(json, false);
}

export function MaterialDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialDeleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'materialId': json['materialId'],
    };
}

export function MaterialDeleteRequestToJSON(value?: MaterialDeleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'materialId': value.materialId,
    };
}

